(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-carousel-layout')) {
    customElements.define('review-carousel-layout', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        this.observer = new MutationObserver(records => {
          if (records.some(record => {
            const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
            return target?.closest('.jdgm-header') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.jdgm-header, .jdgm-cards-carousel') || node.querySelector('.jdgm-header')));
          })) this.formatSummary();
        });
        this.formatSummary();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      formatSummary() {
        this.observer.disconnect();
        this.querySelectorAll('.jdgm-cards-carousel .jdgm-rating-text').forEach(rating => {
          if (rating.querySelector('.nayo-review-score')) return;
          const count = rating.querySelector('.jdgm-reviews-count');
          if (!count) return;
          const directText = [...rating.childNodes].filter(node => node.nodeType === 3).map(node => node.textContent).join(' ');
          const score = (directText || rating.textContent).match(/[\d]+(?:[.,][\d]+)?/);
          if (!score) return;
          const countText = count.textContent.trim().replace(/^\((.*)\)$/, '$1');
          const total = Number(countText.replace(/[^\d]/g, ''));
          const label = total === 1 ? this.dataset.reviewLabel : this.dataset.reviewsLabel;
          const number = document.createElement('span');
          number.className = 'nayo-review-score';
          number.textContent = score[0];
          const details = document.createElement('span');
          details.className = 'nayo-review-count';
          const separator = document.createElement('span');
          separator.textContent = '·';
          separator.setAttribute('aria-hidden', 'true');
          count.textContent = countText;
          details.append(separator, count, document.createTextNode(label ? ` ${label}` : ''));
          rating.replaceChildren(number, details);
        });
        this.observer.observe(this, { childList: true, subtree: true, characterData: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-offers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nayo-discount-offers')) {
    customElements.define('nayo-discount-offers', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.querySelectorAll('[data-copy-code]').forEach(button => { button.hidden = false; });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-copy-code]');
          if (button && this.contains(button)) this.copyCode(button);
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
      async copyCode(button) {
        if (this.copying) return;
        const input = button.closest('.nayo-offers__actions').querySelector('.nayo-offers__code');
        const label = button.querySelector('[data-copy-label]');
        const status = this.querySelector('[role="status"]');
        this.copying = true;
        let copied = false;
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(input.value);
            copied = true;
          }
        } catch {}
        if (!copied) {
          input.focus({ preventScroll: true });
          input.select();
          input.setSelectionRange(0, input.value.length);
          try { copied = document.execCommand('copy'); } catch {}
        }
        if (copied) {
          this.querySelectorAll('[data-copy-code]').forEach(other => {
            if (other.dataset.originalLabel) other.querySelector('[data-copy-label]').textContent = other.dataset.originalLabel;
          });
          button.dataset.originalLabel ||= label.textContent;
          label.textContent = this.dataset.copied;
          status.textContent = `${input.value} — ${this.dataset.success}`;
          button.focus({ preventScroll: true });
        } else {
          status.textContent = this.dataset.manual;
        }
        this.copying = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
